import React, { Component, Fragment, useEffect } from 'react';
import { Navigationmenu } from '../components';
import { Page404 } from '../components/Page404';
import CircularProgress from '@material-ui/core/CircularProgress'
import ReactSession from '../reactclient.js';
import { withRouter } from 'react-router-dom';
import circulargridimage from '../gallery/gridloader.gif';

import { fnPostapiResponse, fnGETapiResponse, Fnencryption } from '../APICall';
import DatePicker from 'react-datepicker';
import moment, { max } from 'moment';
// import 'react-datepicker/dist/react-datepicker.css';
import Footer from '../components/Footer';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { OutTable, ExcelRenderer } from 'react-excel-renderer';



import {
    Box,
    Button,
    Typography,
    Grid,
    TextField,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    FormControl,
    Divider,
    Select,
    InputLabel,
    MenuItem,
    Popover,
    Dialog,
    Tabs,
    Tab,
    DialogActions,
    withStyles,
    TableFooter, Container, Accordion, AccordionSummary,
    AccordionDetails
} from '@material-ui/core';
import Autocomplete from '@mui/material/Autocomplete';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';


import {
    SearchOutlined,
    ArrowDropDown,
    Publish,
    NoteAdd,
    ArrowDropUp,
    InsertDriveFileOutlined,
    QueryBuilderTwoTone
} from '@material-ui/icons';
import {
    ALTERNATEROW_BACKGROUND_COLOR,
    BLUE_COLOR, LIGHTGRAY_COLOR,
    MODIFIEDBLACK,
    PINK_COLOR,
    PROTECT_GREEN,
    RED_COLOR,
    VIBRANT_GREEN, DARKGREEN_COLOR,
    LIGHTGREEN_COLOR
} from "../constants";
import Switch from '@material-ui/core/Switch';
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import List from "@material-ui/core/List";
import renderIf from 'render-if';
import { Redirect } from "react-router-dom";
import axios from "axios"
import { IdleTimeOutModal } from '../components/Logoutmodal';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { useRef } from "react";
const StyledTabs = withStyles({
    indicator: {
        display: 'flex',
        backgroundColor: 'white',
        height: 3
    },
}, { index: 1 })((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);
const SomeComponent = withRouter(props => <IFRS17DataFiles {...props} />);
const StyledTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        color: 'white',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(15),
        '&:focus': {
            opacity: 1
        }
    },
}, { index: 1 }))((props) => <Tab disableRipple {...props} />);
export default class IFRS17DataFiles extends Component {
    state = {
        DBUserName: "",
        DBPassword: "",
        DBSource: "",
        DBProvider: "",
        test: false,
        isloading: "none",
        selectedUser: "",
        selectedPass: "",
        AllBatchId: "",
        batchId: "",
        lablebatchId: "",
        modalmessage: "",
        showModal: false,
        rows: [],
        cols: [], columnsrow: [],
        txtBatchname: "",
        disablebutton: false,
        disablebuttoncolor: BLUE_COLOR,
        viewErrorpage: false,
        batchesarray: [],
        SearchOptions: [],
        SelectedCompany: "",
        selectedYear: "",
        selectedDateRange: "",
        displayloader: 'none',
        tablebuffer: [
        ],
        pagesObj: [],
        pages: 0,
        current: 1,
        records: 0,
        pageSize: 10,
        showPager: false,
        expanded: false, isloading1: false,
        dateDropArray: [],
        yearDropArray: [],
        selectedsearchtype: "SLL Expense Allocation",
        displaySummaryTextbox: '',
        txtValuationYear: '',
        txtAcquisitionCost: '',
        txtMaintenanceCost: '',
        txtRowsCount: '',
        columnvisibleStatusSLL: '',
        columnvisibleStatusReIn:'none'
    }

    /***
     *
     * @param n
     * @returns true if even number
     * @returns false if odd number
     */
    isEven(n) {
        return n % 2 == 0;
    }
    componentDidMount() {
        this.state.selectedUser = sessionStorage.getItem('username')
        this.state.selectedPass = sessionStorage.getItem('password')
        // alert(sessionStorage.getItem('IsTest'))
        this.setState({
            test: sessionStorage.getItem('IsTest'),
            selectedUser: sessionStorage.getItem('username')
        })
        // if (sessionStorage.getItem('allowBatchUsersAccess') == 'true') {
        //     this.setState({ viewErrorpage: false })
        // }
        // else {
        //     this.setState({ viewErrorpage: true })
        // }
        this.fillValuationYear(this.state.selectedsearchtype)

    }
    fillValuationYear(searcttype) {
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'fillValueYRCombo',
            "MAPIPORT": process.env.REACT_APP_MPORT1,
            "body": {

                "databaseDetails": {
                    "DBUserName": sessionStorage.getItem('username'),
                    "DBPassword": sessionStorage.getItem('password'),
                    "DBSource": process.env.REACT_APP_ITC_DBSOURCE,
                    "DBProvider": process.env.REACT_APP_ITC_DBPROVIDER,
                    "Test": this.state.test,
                    "IsWindowsAuth": true
                },
                "FileTypeToUpload": searcttype
            }
        }
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            console.log("View YearDAta", response.data[0])
            if (response.data[0] != undefined)
                this.setState({ yearDropArray: response.data })

        }).catch(e => console.log(e));
    }
    fillDateonyear(drpYear) {
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'fillreportdatecombo',
            "MAPIPORT": process.env.REACT_APP_MPORT1,
            "body": {

                "databaseDetails": {
                    "DBUserName": sessionStorage.getItem('username'),
                    "DBPassword": sessionStorage.getItem('password'),
                    "DBSource": process.env.REACT_APP_ITC_DBSOURCE,
                    "DBProvider": process.env.REACT_APP_ITC_DBPROVIDER,
                    "Test": this.state.test,
                    "IsWindowsAuth": true
                },
                "FileTypeToUpload": this.state.selectedsearchtype,

                "ValuationYR": drpYear
            }
        }
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            console.log("View reportingdate", response.data)
            this.setState({ dateDropArray: response.data })

        }).catch(e => console.log(e));

    }
    handleclose() {
        this.setState({
            showModal: false
        })
    }

    fileHandler = (event) => {
        let fileObj = event.target.files[0];

        //just pass the fileObj as parameter
        ExcelRenderer(fileObj, (err, resp) => {
            if (err) {
                console.log(err);
            }
            else {
                //  console.log("Chcking Exvel Record", resp)
                this.setState({
                    cols: resp.cols,
                    rows: resp.rows
                });

                this.state.columnsrow = resp.rows.shift()
                var pc = resp.rows
                this.state.rows = pc
                if (this.state.selectedsearchtype == "Reinsurance Details") {
                    var reDate = this.state.columnsrow.indexOf('ReportingDate')
                    this.state.rows.forEach(element => {
                        this.state.rows[this.state.rows.indexOf(element)][reDate] = this.state.rows[this.state.rows.indexOf(element)][reDate] == undefined ? "" : this.fntoConvertdate(this.state.rows[this.state.rows.indexOf(element)][reDate])
                    });
                    console.log("All rows", this.state.rows)
                    this.state.rows.unshift(this.state.columnsrow)
                    this.setState({ displaySummaryTextbox: 'none' })
                } else {
                    var sumaquat = 0
                    var sumaMaint = 0
                    var aquatIndex = this.state.columnsrow.indexOf('Acquisition Cost')
                    var maintIndex = this.state.columnsrow.indexOf('Maintenance Cost')
                    var reDate = this.state.columnsrow.indexOf('Reporting Date')
                    console.log("All rows", this.state.rows)
                    this.state.rows.forEach(element => {
                        sumaquat += this.state.rows[this.state.rows.indexOf(element)][aquatIndex] == undefined ? 0 : this.state.rows[this.state.rows.indexOf(element)][aquatIndex]
                        sumaMaint += this.state.rows[this.state.rows.indexOf(element)][maintIndex] == undefined ? 0 : this.state.rows[this.state.rows.indexOf(element)][maintIndex]
                        this.state.rows[this.state.rows.indexOf(element)][reDate] = this.state.rows[this.state.rows.indexOf(element)][reDate] == undefined ? "" : this.fntoConvertdate(this.state.rows[this.state.rows.indexOf(element)][reDate])

                    });
                    this.state.rows = this.state.rows.filter(value => value[0] != undefined);
                    this.state.rows.unshift(this.state.columnsrow)
                    this.setState({
                        txtValuationYear: this.state.rows[1][this.state.columnsrow.indexOf('Val_Yr')],
                        txtRowsCount: this.state.rows.length,
                        txtAcquisitionCost: sumaquat.toLocaleString(undefined, { maximumFractionDigits: 2 }), txtMaintenanceCost: sumaMaint.toLocaleString(undefined, { maximumFractionDigits: 2 })
                    })
                }
            }
        });
    }
    fntoConvertdate(excelDate) {
        var date = new Date(Math.round((excelDate - (25569)) * 86400 * 1000));
        var converted_date = date.toISOString().split('T')[0];
        // console.log("converted_date ye he " , converted_date);
        return converted_date
    }

    handleSerachChange(e, key) {
        this.setState({ key: e.target.value });
        this.state[key] = e.target.value;
    }

    handlerdelete() {
        var r = window.confirm("Are you sure you want delete this record ?")
        if (r) {
            this.state.isloading1 = true
            var data =
            {
                "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
                "MAPINAME": 'DELETEIFRS17DATA',
                "MAPIPORT": process.env.REACT_APP_MPORT1,
                "body": {

                    "databaseDetails": {
                        "DBUserName": sessionStorage.getItem('username'),
                        "DBPassword": sessionStorage.getItem('password'),
                        "DBSource": process.env.REACT_APP_ITC_DBSOURCE,
                        "DBProvider": process.env.REACT_APP_ITC_DBPROVIDER,
                        "Test": this.state.test,
                        "IsWindowsAuth": true
                    },
                    "FileTypeToUpload": this.state.selectedsearchtype,
                    "Reporting_Date": this.state.selectedDateRange,
                    "ValuationYR": this.state.selectedYear
                }
            }
            fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
                console.log("table ka delete", response.data)
                alert(response.data)
                window.location.reload()

            }).catch(e => console.log(e));
        }
    }
    ViewExisting() {
        this.state.isloading1 = true
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'GETIFRS17DATA',
            "MAPIPORT": process.env.REACT_APP_MPORT1,
            "body": {

                "databaseDetails": {
                    "DBUserName": sessionStorage.getItem('username'),
                    "DBPassword": sessionStorage.getItem('password'),
                    "DBSource": process.env.REACT_APP_ITC_DBSOURCE,
                    "DBProvider": process.env.REACT_APP_ITC_DBPROVIDER,
                    "Test": this.state.test,
                    "IsWindowsAuth": true
                },

                "Reporting_Date": this.state.selectedDateRange,
                "ValuationYR": this.state.selectedYear,
                "FileTypeToUpload": this.state.selectedsearchtype

            }
        }
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            console.log("table ka vata", response.data)
            this.setState({ alldata: response.data, isloading1: false })
            console.log("Data :- ", this.state.alldata)

            this.renderpages()

        }).catch(e => console.log(e));

    }
    SaveFigures() {

        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'UploadExpense',
            "MAPIPORT": process.env.REACT_APP_MPORT1,
            "body": {

                "databaseDetails": {
                    "DBUserName": sessionStorage.getItem('username'),
                    "DBPassword": sessionStorage.getItem('password'),
                    "DBSource": process.env.REACT_APP_ITC_DBSOURCE,
                    "DBProvider": process.env.REACT_APP_ITC_DBPROVIDER,
                    "Test": this.state.test,
                    "IsWindowsAuth": true
                },
                "FileTypeToUpload": this.state.selectedsearchtype,
                "columnnames": this.state.columnsrow,
                "columnvalues": this.state.rows,
            }
        }
        console.log("save ki body", data)
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            console.log("Save Figure Console", response.data)
            // console.log("response of Inpatientexcelupload", response.data)
            alert(response.data)
            // this.fnloadAllBactchID()
            this.handlercancel()
        }).catch(e => console.log(e));
    }


    BatchUploading(e) {
        if (this.state.AllBatchId.slice(0, 1).trim() == "") {
            alert("Please Enter Atleast One Batch ID")
        }
        else {
            this.setState({
                isloading: "block"
            })
            var batchID = (this.state.AllBatchId.split("@"))[0]
            var batchCount = (this.state.AllBatchId.split("@"))[1].slice(0, -1)
            alert("There are " + batchCount + " rows. It will take around " + batchCount + " seconds to completely upload batch.");
            this.setState({ displayloader: '' })
            var data =
            {
                "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
                "MAPINAME": 'BatchUpload',
                "MAPIPORT": '' + process.env.REACT_APP_MPORT1 + '',
                "body": {
                    "databaseDetails": {
                        "DBUserName": this.state.selectedUser,
                        "DBPassword": Fnencryption(this.state.selectedPass),
                        "DBSource": process.env.REACT_APP_ITC_DBSOURCE,
                        "DBProvider": process.env.REACT_APP_ITC_DBPROVIDER,
                        "Test": this.state.test,
                        "IsWindowsAuth": true
                    },
                    "batchID": batchID.slice(0, -1),
                    "reprocessBatch": false
                }
            }
            console.log("Batch Body", data)
            fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
                // console.log("BatchId Response",response)
                // console.log("BatchId Res",response.data)
                // this.searchandsave(data, response.data.SearchResultMSG.length,response1.data.SearchResultMSG.length)
                this.setState({ displayloader: 'none' })

                this.setState({
                    isloading: "none",
                    showModal: true,
                    // AllBatchId: "",
                    batchId: "",
                    modalmessage: response.data
                })
                // alert(response.data)
            }).catch(e => console.log(e),
            );
        }
    }
    handleLogout() {
        this.setState({
            redirect: true,
            direction: "/AML"
        })
    }
    fnloadAllBactchID() {
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'GetAMLBatches',
            "MAPIPORT": process.env.REACT_APP_MPORT1,
            "body": {
                "databaseDetails": {
                    "DBUserName": sessionStorage.getItem('username'),
                    "DBPassword": sessionStorage.getItem('password'),
                    "DBSource": process.env.REACT_APP_ITC_DBSOURCE,
                    "DBProvider": process.env.REACT_APP_ITC_DBPROVIDER,
                    "Test": sessionStorage.getItem('IsTest'),
                    "IsWindowsAuth": true
                }
            }
        }
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'postApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            var rowObj = response.data
            console.log("AllBatchID's", rowObj)
            var pc = []
            {
                for (var i of rowObj) {
                    pc.push(i.BATCHID.toString() + "@" + i.BATCHCOUNT.toString());
                }
            }
            console.log("Selected", pc)
            this.setState({
                batchesarray: rowObj, SearchOptions: pc
            })
        }).catch(e => console.log(e));
    }
    fntosetBatchId(companyname) {

        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'GenrateNewBatchID',
            "MAPIPORT": process.env.REACT_APP_MPORT1,
            "body": {
                "databaseDetails": {
                    "DBUserName": sessionStorage.getItem('username'),
                    "DBPassword": sessionStorage.getItem('password'),
                    "DBSource": process.env.REACT_APP_ITC_DBSOURCE,
                    "DBProvider": process.env.REACT_APP_ITC_DBPROVIDER,
                    "Test": sessionStorage.getItem('IsTest'),
                    "IsWindowsAuth": true
                },
                "company": companyname
            }
        }
        console.log("result", data)
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'postApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            var rowObj = response.data
            console.log("New Genrated BatchId", rowObj)
            this.setState({ txtBatchname: rowObj })
        }).catch(e => console.log(e));
    }
    handleSelectedsearchtype(searchType) {
        if (searchType == "Reinsurance Details") { this.setState({ displaySummaryTextbox: 'none' }) }
        else { this.setState({ displaySummaryTextbox: '' }) }
    }
    handleSelectedsearchtype1(searchType) {
        if (searchType == "Reinsurance Details") { this.setState({ columnvisibleStatusSLL: 'none',columnvisibleStatusReIn:'' }) }
        else {
            this.setState({columnvisibleStatusSLL : '',columnvisibleStatusReIn:'none'})
        }
        this.fillValuationYear(searchType)
    }
    handlercancel() {
        //  var r = window.confirm("Do you really want Cancel ?")
        // if (r == true)
        //   window.location.reload();
        let randomString = Math.random().toString(36);
        this.setState({
            theInputKey: randomString
        });
        this.setState({
            txtAcquisitionCost: "",
            txtMaintenanceCost: "",
            txtRowsCount: "",
            txtValuationYear: "",
            selectedsearchtype: "SLL Expense Allocation",
            displaySummaryTextbox: '',
            rows: [],
            cols: [],
        })

    }
    pageChange(number) {
        this.state.current = number;
        var data = this.state.alldata.slice(this.state.current * this.state.pageSize, (this.state.current + 1) * this.state.pageSize);
        this.setState({ tablebuffer: data })

        this.state.pagesObj = [];
        if (this.state.pages < 10) {
            for (var i = 0; i < this.state.pages; i++)
                this.state.pagesObj.push(i);
        }
        else {
            var min = this.state.current - 5;
            var max = this.state.current + 5;
            if (min < 0)
                min = 0;
            if (max > this.state.pages)
                max = this.state.pages;
            if (max - min > 10) {
                min = this.state.current - 5;
                max = this.state.current + 5;
            }
            if (min > 0)
                this.state.pagesObj.push(0);
            for (var i = min; i < max; i++)
                this.state.pagesObj.push(i);
            if (max < this.state.pages - 1)
                this.state.pagesObj.push(this.state.pages - 1);
        }
    }
    renderpages() {
        this.state.records = this.state.alldata.length;
        this.state.pages = parseInt(this.state.records / this.state.pageSize)
        if (this.state.records % this.state.pageSize > 0)
            this.state.pages++;
        this.state.showPager = this.state.pages > 1
        this.pageChange(0)
    }
    render() {

        return (

            <Fragment>
                {this.state.redirect &&
                    <Redirect to={this.state.direction} />
                }
                {!this.state.viewErrorpage ?
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        style={{ marginTop: 35 }}
                    >
                        <Navigationmenu selectedMenu={''} />

                        <Paper elevation={2} style={{ minHeight: 100, width: '90%', borderRadius: 6 }}>
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                            >
                                <div style={{ minHeight: 100, width: '98%', borderRadius: 6 }}>

                                    <Grid container spacing={2} >
                                        <Grid item xs={11}>
                                            <div style={{
                                                display: 'flex',
                                                marginBottom: 20,
                                                marginTop: 60
                                            }}>
                                                <Typography style={{ borderWidth: 0, color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 30, paddingLeft: 10 }}>IFRS17 Data Files Upload</Typography>
                                            </div>
                                        </Grid>
                                        <Grid item xs={1}>
                                            <Box
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="center"
                                            >
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <div>

                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ArrowDropDown />}
                                                aria-controls="panel2a-content"
                                                id="panel2a-header"
                                            >
                                                <Typography style={{ borderWidth: 0, color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 18, paddingLeft: 10 }}>UPLOAD IFRS17 DATA FILES</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Grid container spacing={3} >

                                                    <Grid item xs={2}>
                                                        <Typography style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 13, paddingLeft: 10 }}>
                                                            File Type To Upload</Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <Select
                                                            style={{ width: '220px', height: '32px' }}
                                                            variant={'outlined'}
                                                            value={this.state.selectedsearchtype}
                                                            onChange={e => this.setState({ selectedsearchtype: e.target.value }
                                                                , this.handleSelectedsearchtype(e.target.value)
                                                            )}
                                                        >
                                                            <MenuItem value={'SLL Expense Allocation'}>SLL Expense Allocation</MenuItem>
                                                            <MenuItem value={'SG Expense Allocation'}>SG Expense Allocation</MenuItem>
                                                            <MenuItem value={'Reinsurance Details'}>Reinsurance Details</MenuItem>
                                                        </Select>
                                                    </Grid>
                                                    <Grid item xs={4}></Grid>
                                                    <Grid item xs={2}>
                                                        <Typography style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 13, paddingLeft: 10 }}>
                                                            Path for the excel</Typography>
                                                    </Grid>
                                                    <Grid item xs={5}>

                                                        <input type="file" key={this.state.theInputKey || ''} onChange={this.fileHandler.bind(this)} style={{ width: '100%' }} />
                                                    </Grid>
                                                    <Grid item xs={5}>
                                                        <Button variant={'text'} onClick={(e) => this.SaveFigures()} style={{ color: 'white', fontFamily: 'Globerbold', marginLeft: "-180px", backgroundColor: BLUE_COLOR, width: '50%', height: '40px', fontSize: 16, paddingLeft: 10 }}>
                                                            Post File to datastore </Button>

                                                        <Button variant={'text'} onClick={(e) => this.handlercancel()} style={{ color: 'white', fontFamily: 'Globerbold', marginLeft: "2px", backgroundColor: BLUE_COLOR, marginTop: "1px", width: '120px', height: "40px", fontSize: 16 }}>
                                                            CLEAR
                                                        </Button>
                                                    </Grid>
                                                    <Grid item xs={1} style={{ display: this.state.displaySummaryTextbox }}>
                                                        <Typography style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 13, paddingLeft: 10 }}>
                                                            Valuation Year</Typography></Grid>
                                                    <Grid item xs={2} style={{ display: this.state.displaySummaryTextbox }}>
                                                        <TextField disabled
                                                            value={this.state.txtValuationYear}
                                                            variant='outlined'
                                                            onChange={(e) => this.handleSerachChange(e, "txtValuationYear")}
                                                            InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK, height: '30px', marginLeft: '0px' } }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={1} style={{ display: this.state.displaySummaryTextbox }}>
                                                        <Typography style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 13, paddingLeft: 10 }}>
                                                            Acquisition Cost</Typography></Grid>
                                                    <Grid item xs={2} style={{ display: this.state.displaySummaryTextbox }}>
                                                        <TextField disabled
                                                            value={this.state.txtAcquisitionCost}
                                                            variant='outlined'
                                                            onChange={(e) => this.handleSerachChange(e, "txtAcquisitionCost")}
                                                            InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK, height: '30px', marginLeft: '0px' } }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={1} style={{ display: this.state.displaySummaryTextbox }}>
                                                        <Typography style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 13, paddingLeft: 10 }}>
                                                            Maintenance Cost</Typography></Grid>
                                                    <Grid item xs={2} style={{ display: this.state.displaySummaryTextbox }}>
                                                        <TextField disabled
                                                            value={this.state.txtMaintenanceCost}
                                                            variant='outlined'
                                                            onChange={(e) => this.handleSerachChange(e, "txtMaintenanceCost")}
                                                            InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK, height: '30px', marginLeft: '0px' } }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={1} style={{ display: this.state.displaySummaryTextbox }}>
                                                        <Typography style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 13, paddingLeft: 10 }}>
                                                            Rows Count</Typography></Grid>
                                                    <Grid item xs={2} style={{ display: this.state.displaySummaryTextbox }}>
                                                        <TextField disabled
                                                            value={this.state.txtRowsCount}
                                                            variant='outlined'
                                                            onChange={(e) => this.handleSerachChange(e, "txtRowsCount")}
                                                            InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK, height: '30px', marginLeft: '0px' } }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <img style={{ width: "100px", display: this.state.displayloader }} src={circulargridimage} alt="circulargridimage" />
                                                    </Grid>
                                                    <div style={{ overflow: 'scroll', maxHeight: '200px' }}>
                                                        <OutTable style={{ width: 'max-content' }} data={this.state.rows} columns={this.state.cols} tableClassName="ExcelTable2007" tableHeaderRowClass="heading" />
                                                    </div>

                                                    <Grid item xs={4}></Grid>
                                                </Grid>

                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ArrowDropDown />}
                                                aria-controls="panel2a-content"
                                                id="panel2a-header"
                                            >
                                                <Typography style={{ borderWidth: 0, color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 18, paddingLeft: 10 }}>VIEW EXISTING RECORDS</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={2}>
                                                        <Typography style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 13, paddingLeft: 10 }}>
                                                            File Type To Upload</Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <Select
                                                            style={{ width: '220px', height: '32px' }}
                                                            variant={'outlined'}
                                                            value={this.state.selectedsearchtype}
                                                            onChange={e => this.setState({ selectedsearchtype: e.target.value }
                                                                , this.handleSelectedsearchtype1(e.target.value)
                                                            )}
                                                        >
                                                            <MenuItem value={'SLL Expense Allocation'}>SLL Expense Allocation</MenuItem>
                                                            <MenuItem value={'SG Expense Allocation'}>SG Expense Allocation</MenuItem>
                                                            <MenuItem value={'Reinsurance Details'}>Reinsurance Details</MenuItem>
                                                        </Select>
                                                    </Grid>
                                                    <Grid item xs={4}></Grid>
                                                    <Grid item xs={2}>
                                                        <Typography style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 13, paddingLeft: 10 }}>
                                                            Selected Valuation Year</Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <Select
                                                            style={{ width: '220px', height: '32px' }}
                                                            variant={'outlined'}
                                                            value={this.state.selectedYear}
                                                            onChange={e => this.setState({ selectedYear: e.target.value },
                                                                this.fillDateonyear(e.target.value)
                                                            )}
                                                        >
                                                            {this.state.yearDropArray.map((team) => (
                                                                <MenuItem value={team.ValuationYr}>
                                                                    {team.ValuationYr}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </Grid>
                                                    <Grid item xs={4}></Grid>
                                                    <Grid item xs={2}>
                                                        <Typography style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 13, paddingLeft: 10 }}>
                                                            Selected Reporting Date</Typography>
                                                    </Grid>

                                                    <Grid item xs={5}>
                                                        <Select
                                                            style={{ width: '220px', height: '32px' }}
                                                            variant={'outlined'}
                                                            value={this.state.selectedDateRange}
                                                            onChange={e => this.setState({ selectedDateRange: e.target.value }
                                                            )}
                                                        >
                                                            {this.state.dateDropArray.map((team) => (
                                                                <MenuItem value={team.reportingDate}>
                                                                    {team.reportingDate}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </Grid>
                                                    <Grid item xs={5}>
                                                        <Button variant={'text'} onClick={(e) => this.ViewExisting()} style={{ color: 'white', fontFamily: 'Globerbold', marginLeft: "-180px", backgroundColor: BLUE_COLOR, width: '120px', height: '40px', fontSize: 16, paddingLeft: 10 }}>
                                                            View </Button>
                                                        <Button variant={'text'} onClick={(e) => this.handlerdelete()} style={{ color: 'white', fontFamily: 'Globerbold', marginLeft: "2px", backgroundColor: RED_COLOR, marginTop: "1px", width: '120px', height: "40px", fontSize: 16 }}>
                                                            DELETE
                                                        </Button>
                                                    </Grid>
                                                    <TableContainer>
                                                        <Table aria-label="table">
                                                            <TableHead style={{ backgroundColor: 'rgba(241,241,241,1.0)' }}>
                                                                <TableRow>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "150px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusSLL }} align="center">policyGroupID</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "120px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusSLL }} align="center">Acquisition Cost</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusSLL }} align="center">Maintenance Cost</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusSLL }} align="center">ReportingDate</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusSLL }} align="center">IFRS17_MEASUREMENT_MODEL</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusSLL }} align="center">ValuationYr</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusSLL }} align="center">ValPeriod</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">SourceRecordId</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">SourceSystemId</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">PolicyId</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">PolicyGroupId</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">UnderlyingPolicyGroupId</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">CashFlowModelId</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">CashFlowModelStepId</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">ChangeType</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">AssumptionId</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">ReportingDate</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">CashFlowDate</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">SourceEvent</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">CashFlowType</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">ProductId</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">PeriodIndicator</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">CashFlowAmount</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">CashFlowAmount2</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">CashFlowCurrencyId</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">OrderId</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">ClientAttr</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">ValYear</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">ValPeriod</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">createdDate</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatusReIn }} align="center">STATUS</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {!this.state.isloading1 ?
                                                                    this.state.tablebuffer.map((obj, index) => {
                                                                        var rowbackgroundColor = 'white';
                                                                        if (this.isEven(index)) { rowbackgroundColor = ALTERNATEROW_BACKGROUND_COLOR; }

                                                                        if (this.state.ishovered && this.state.hoverindex == index) { rowbackgroundColor = LIGHTGRAY_COLOR }
                                                                        if (obj != undefined) {
                                                                            return (
                                                                                <TableRow style={{ cursor: 'pointer' }} key={index} hover={true} onMouseOut={() => this.setState({ ishovered: false })} onMouseEnter={() => this.setState({ hoverindex: index, ishovered: true })}>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusSLL }} align="center">{obj.policyGroupID}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusSLL }} align="center">{obj['Acquisition Cost']}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusSLL }} align="center">{obj['Maintenance Cost']}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusSLL }} align="center">{obj.reportingDate}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusSLL }} align="center">{obj.IFRS17_MEASUREMENT_MODEL}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusSLL }} align="center">{obj.ValuationYr}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusSLL }} align="center">{obj.ValPeriod}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.SourceRecordId}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.SourceSystemId}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.PolicyId}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.PolicyGroupId}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.UnderlyingPolicyGroupId}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.CashFlowModelId}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.CashFlowModelStepId}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.ChangeType}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.AssumptionId}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.ReportingDate}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.CashFlowDate}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.SourceEvent}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.CashFlowType }</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.ProductId}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.PeriodIndicator}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.CashFlowAmount}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.CashFlowAmount2}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.CashFlowCurrencyId}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.OrderId}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.ClientAttr}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.ValYear}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.ValPeriod}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.createdDate}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatusReIn }} align="center">{obj.STATUS}</TableCell>
                                                                                </TableRow>
                                                                            )
                                                                        }
                                                                    })
                                                                    : <td style={{ marginLeft: "500px", height: "100px" }}>
                                                                        {/* Loading.... <CircularProgress classes="CircularProgress" /> */}
                                                                        <img style={{ width: "100px" }} src={circulargridimage} alt="circulargridimage" />;
                                                                    </td>}
                                                            </TableBody>
                                                        </Table>
                                                        <div style={this.state.showPager ? { height: 60, marginLeft: "500px", color: MODIFIEDBLACK, fontSize: "15px", textTransform: 'uppercase', fontFamily: 'Globerbold', wordBreak: "break-word" } : { display: "none" }} >
                                                            {
                                                                this.state.pagesObj.map((obj, index) => {
                                                                    return (
                                                                        <span style={{ padding: "0 3px", cursor: "pointer" }}>
                                                                            <a style={this.state.current == obj ? { fontWeight: 'bold', color: BLUE_COLOR, fontSize: "30px" } : {}} onClick={() => this.pageChange(obj)} >{obj + 1}</a>
                                                                        </span>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </TableContainer>
                                                </Grid>


                                            </AccordionDetails>
                                        </Accordion>

                                    </div>
                                    <div style={{ height: 10 }} />
                                    <Divider></Divider>
                                    <img style={{ width: "100px", marginLeft: "500px", display: this.state.isloading }} src={circulargridimage} alt="circulargridimage" />

                                    <br></br>
                                    {/* Disclaimer: You are kindly advised that we will retain audit trails of searches made on the AML Watchlist for monitoring purposes. */}
                                    <br></br>
                                    {/* <Footer></Footer> */}
                                    <br></br>
                                    <Dialog fullWidth open={this.state.showModal} onClose={e => this.handleclose()} aria-labelledby="form-dialog-title">
                                        <DialogTitle id="form-dialog-title">Message</DialogTitle>
                                        <Divider variant="middle" />
                                        <DialogContent>
                                            {this.state.modalmessage}.
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={() => this.setState({ showModal: false })} color="primary">
                                                OK
                                            </Button>
                                        </DialogActions>
                                    </Dialog>


                                </div>
                            </Box>
                        </Paper>
                    </Box>
                    :
                    <Page404
                        h3text='Sorry, You have no Access for this page !!'
                        txtsecondary='Please Ask To Admin For Further details !'
                        bgcolor='goldenrod'
                    ></Page404>
                }
            </Fragment>
        )
    }
}